import { render, staticRenderFns } from "./EDialogFormTypeProductComp.vue?vue&type=template&id=c761d7ba&"
import script from "./EDialogFormTypeProductComp.vue?vue&type=script&lang=js&"
export * from "./EDialogFormTypeProductComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports